import { request } from '../utils/Api';

export function getMember(id, accessToken) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`member/${id}`, 'GET', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MEMBER_BY_ID',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function updateProfile(fields) {
  return dispatch => (
    new Promise((resolve) => {
      dispatch({
        type: 'UPDATE_PROFILE',
        payload: fields,
      });

      resolve();
    })
  );
}

export function addProfileArrayKey(name, id) {
  let action;

  switch (name) {
    default:
      action = 'ADD_PROFILE_NEED';
      break;
    case 'needs':
      action = 'ADD_PROFILE_NEED';
      break;
    case 'interests':
      action = 'ADD_PROFILE_INTEREST';
      break;
  }

  return dispatch => (
    new Promise((resolve) => {
      dispatch({
        type: action,
        payload: id,
      });

      resolve();
    })
  );
}

export function removeProfileArrayKey(name, id) {
  let action;

  switch (name) {
    default:
      action = 'REMOVE_PROFILE_NEED';
      break;
    case 'needs':
      action = 'REMOVE_PROFILE_NEED';
      break;
    case 'interests':
      action = 'REMOVE_PROFILE_INTEREST';
      break;
  }

  return dispatch => (
    new Promise((resolve) => {
      dispatch({
        type: action,
        payload: id,
      });

      resolve();
    })
  );
}



// WEBPACK FOOTER //
// ./src/actions/profile.js